import React, { Fragment } from 'react';
import { Col, Row } from 'react-bootstrap';
import BaseComponent, { connect } from '@common/components/base.component';
import { ddados } from '../solicitarBaixaMei.ddados';
import DDadosItem from '@common/components/ddados/ddados.item';
import autobind from 'react-autobind';
import solicitarBaixaMeiSelector from '../store/solicitarBaixaMei.selectors';
import solicitarBaixaMeiActions from '../store/solicitarBaixaMei.actions';
import GridSolicitarBaixaMei from './solicitarBaixaMei.pesquisa';
import SolicitarBaixaMeiModal from './solicitarBaixaMei.modal';
import Form from '@common/externos/components/validation/form.validation';
import Recaptcha from 'react-recaptcha';

class Container extends BaseComponent {
  constructor(props) {
    super(props);
    autobind(this);
  }

  verifyCallback(response) {
    this.props.solicitarBaixaMeiActions.setTokenRecaptcha(response);
  }

  expiredCallback() {
    this.props.solicitarBaixaMeiActions.setTokenRecaptcha('');
  }

  recaptchaRef(ref) {
    this.props.solicitarBaixaMeiActions.setRecaptchaResetRef(ref?.reset);
  }

  onSubmit(values) {
    this.props.solicitarBaixaMeiActions.pesquisarSolicitarBaixaMei(values);
  }

  onCancel() {
    const { routerManager } = this.props;
    routerManager.redirect({ name: 'RedeSIM' });
  }

  render() {
    const { solicitarBaixaMei } = this.props.solicitarBaixaMeiSelector;
    const MostrarGridSolicitarBaixaMeiPesquisa = solicitarBaixaMei.GridSolicitarBaixaMeiPesquisa?.length > 0;
    const { Campos } = ddados;

    return (
      <>
        {solicitarBaixaMei.SolicitarBaixaMeiModalToggle && <SolicitarBaixaMeiModal />}

        {MostrarGridSolicitarBaixaMeiPesquisa && !solicitarBaixaMei.SolicitarBaixaMeiModalToggle && (
          <GridSolicitarBaixaMei />
        )}

        {!MostrarGridSolicitarBaixaMeiPesquisa && !solicitarBaixaMei.SolicitarBaixaMeiModalToggle && (
          <Form onSubmit={this.onSubmit} onCancel={this.onCancel} isView={false}>
            {(form) => (
              <Fragment>
                <Row>
                  <Col xs={12} lg={4}>
                    <DDadosItem name="CpfCnpjSolicitante" {...Campos.CpfCnpjSolicitante} />
                  </Col>
                  <Col xs={12} lg={4}>
                    <DDadosItem name="CpfMei" {...Campos.CpfMei} />
                  </Col>
                  <Col xs={12} lg={4}>
                    <DDadosItem name="CnpjEmpresa" {...Campos.CnpjEmpresa} />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} lg={4}>
                    <Recaptcha
                      elementID="1"
                      ref={this.recaptchaRef}
                      sitekey={'6LeSHQETAAAAACjgu00LxcbscsmkkwMIqhfd1-Gh'}
                      verifyCallback={this.verifyCallback}
                      render={'explicit'}
                      expiredCallback={this.expiredCallback}
                      hl="pt-br"
                      theme="light"
                      size="normal"
                    />
                  </Col>
                </Row>
              </Fragment>
            )}
          </Form>
        )}
      </>
    );
  }
}

export default connect({
  actions: {
    solicitarBaixaMeiActions,
  },
  selectors: {
    solicitarBaixaMeiSelector,
  },
})(Container);
